import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { ButtonHTMLAttributes } from 'react';
interface PaymentButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  finalAmount: number;
  totalCount: number;
  size?: 'small' | 'large';
  className?: string;
}
export function PaymentButton(t0) {
  const $ = _c(42);
  let className;
  let disabledProp;
  let finalAmount;
  let props;
  let t1;
  let totalCount;
  if ($[0] !== t0) {
    ({
      finalAmount,
      totalCount,
      size: t1,
      className,
      disabled: disabledProp,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabledProp;
    $[3] = finalAmount;
    $[4] = props;
    $[5] = t1;
    $[6] = totalCount;
  } else {
    className = $[1];
    disabledProp = $[2];
    finalAmount = $[3];
    props = $[4];
    t1 = $[5];
    totalCount = $[6];
  }
  const size = t1 === undefined ? "large" : t1;
  const isSmall = size === "small";
  const isDisabled = disabledProp || totalCount === 0;
  const t2 = isDisabled ? "bg-Gray-100" : "bg-O-400";
  const t3 = isSmall ? "h-56" : "h-68";
  let t4;
  if ($[7] !== className || $[8] !== t2 || $[9] !== t3) {
    t4 = cn("flex w-full items-center justify-center gap-4", t2, t3, className);
    $[7] = className;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = isDisabled ? "text-Gray-400" : "text-Gray-white";
  const t6 = isSmall ? "typo-h7 mobile-tablet:typo-body4" : "typo-h6";
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = cn("font-700", t5, t6);
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== finalAmount) {
    t8 = finalAmount.toLocaleString();
    $[14] = finalAmount;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <span className={t7}>{t8}원</span>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = isDisabled ? "text-Gray-400" : "text-Gray-white";
  const t11 = isSmall ? "typo-h7 mobile-tablet:typo-body4" : "typo-h6";
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = cn("font-700", t10, t11);
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <span className={t12}>결제하기</span>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = isSmall ? "size-24 mobile-tablet:size-16" : "size-24";
  let t15;
  if ($[24] !== t14) {
    t15 = cn("flex items-center justify-center rounded-pill bg-Gray-white", t14);
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = isDisabled ? "text-Gray-400" : "text-O-400";
  const t17 = isSmall && "mobile-tablet:!text-[10px] mobile-tablet:font-800 mobile-tablet:!leading-none";
  let t18;
  if ($[26] !== t16 || $[27] !== t17) {
    t18 = cn(t16, "font-700 typo-body3", t17);
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t18 || $[30] !== totalCount) {
    t19 = <span className={t18}>{totalCount}</span>;
    $[29] = t18;
    $[30] = totalCount;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t15 || $[33] !== t19) {
    t20 = <span className={t15}>{t19}</span>;
    $[32] = t15;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== isDisabled || $[36] !== props || $[37] !== t13 || $[38] !== t20 || $[39] !== t4 || $[40] !== t9) {
    t21 = <button type="button" disabled={isDisabled} className={t4} {...props}>{t9}{t13}{t20}</button>;
    $[35] = isDisabled;
    $[36] = props;
    $[37] = t13;
    $[38] = t20;
    $[39] = t4;
    $[40] = t9;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  return t21;
}